import Logger from "../../../services/Logger";

const CAMBRIDGE_API_KEY = "eVXGB2pyXqVhzTuNhEWQ03Uv1CnWbp6VHG9jIVMkT5gNrvAyuMDzsKwoZRh2VIJx";

const CambridgeService = {
    searchWords: async (query, pageIndex = 1, pageSize = 10) => {
        const url = `/cambridge/api/v1/dictionaries/american-english/search?pageindex=${pageIndex}&pagesize=${pageSize}&q=${encodeURIComponent(query)}`;
        
        const response = await fetch(url, {
            headers: {
                accessKey: CAMBRIDGE_API_KEY,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Search failed: ${response.status}`);
        }

        const result = await response.json();
        Logger.log(result);
        return result;
    },

    getWordDefinition: async (entryId) => {
        const url = `/cambridge/api/v1/dictionaries/american-english/entries/${entryId}`;
        
        const response = await fetch(url, {
            headers: {
                accessKey: CAMBRIDGE_API_KEY,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Definition fetch failed: ${response.status}`);
        }

        const result = await response.json();
        Logger.log(result);
        return result;
    },

    getRelatedEntries: async (entryId, dictCode = "american-english") => {
        const url = `/cambridge/api/v1/dictionaries/${dictCode}/entries/${entryId}/relatedentries`;
        
        const response = await fetch(url, {
            headers: {
                accessKey: CAMBRIDGE_API_KEY,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Related entries fetch failed: ${response.status}`);
        }

        const result = await response.json();
        Logger.log(result);
        return result;
    },

    getNearbyEntries: async (entryId, dictCode = "american-english", entryNumber = 5) => {
        const url = `/cambridge/api/v1/dictionaries/${dictCode}/entries/${entryId}/nearbyentries?entrynumber=${entryNumber}`;
        
        const response = await fetch(url, {
            headers: {
                accessKey: CAMBRIDGE_API_KEY,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Nearby entries fetch failed: ${response.status}`);
        }

        const result = await response.json();
        Logger.log(result);
        return result;
    },

    getSpellingSuggestions: async (query, dictCode = "american-english", entryNumber = 10) => {
        const url = `/cambridge/api/v1/dictionaries/${dictCode}/search/didyoumean?q=${encodeURIComponent(query)}&entrynumber=${entryNumber}`;
        
        const response = await fetch(url, {
            headers: {
                accessKey: CAMBRIDGE_API_KEY,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Spelling suggestions fetch failed: ${response.status}`);
        }

        const result = await response.json();
        Logger.log(result);
        return result;
    },

    getWordOfTheDay: async () => {
        const url = `/cambridge/api/v1/wordoftheday`;
        
        const response = await fetch(url, {
            headers: {
                accessKey: CAMBRIDGE_API_KEY,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Word of the day fetch failed: ${response.status}`);
        }

        const result = await response.json();
        Logger.log(result);
        return result;
    },

    getWordOfTheDayPreview: async () => {
        const url = `/cambridge/api/v1/wordoftheday/preview`;
        
        const response = await fetch(url, {
            headers: {
                accessKey: CAMBRIDGE_API_KEY,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Word of the day preview fetch failed: ${response.status}`);
        }

        const result = await response.json();
        Logger.log(result);
        return result;
    },
};

export default CambridgeService;
